import { default as CategoryColor, type CategoryColorValue } from "../schema/CategoryColor";

let cachedLightMap: {
    [color: string]: CategoryColorValue;
} | undefined;

export function getLightColorCodeValueMap(): {
    [color: string]: CategoryColorValue;
} {
    if (!cachedLightMap) {
        cachedLightMap = {
            [CategoryColor.None]: {
                primaryColor: "transparent",
                secondaryColor: "#d1d1d1",
                iconColor: "#242424",
                textColor: "#424242",
                hoverColor: "#f5f5f5",
                calendarColor: "transparent",
                hoverTextBorderColor: "#424242",
                pressedBackgroundColor: "#f5f5f5",
                pressedTextBorderColor: "#424242",
            },
            
            [CategoryColor.DarkRed]: {
                primaryColor: "#E9C7CD",
                secondaryColor: "#AC4F5E",
                iconColor: "#750B1C",
                textColor: "#420610",
                hoverColor: "#D69CA5",
                calendarColor: "#750B1C",
                hoverTextBorderColor: "#420610",
                pressedBackgroundColor: "#E9C7CD",
                pressedTextBorderColor: "#130204",
            },
            
            [CategoryColor.Cranberry]: {
                primaryColor: "#F6D1D5",
                secondaryColor: "#DC626D",
                iconColor: "#C50F1F",
                textColor: "#6E0811",
                hoverColor: "#EEACB2",
                calendarColor: "#C50F1F",
                hoverTextBorderColor: "#6E0811",
                pressedBackgroundColor: "#DC626D",
                pressedTextBorderColor: "#200205",
            },
            
            [CategoryColor.DarkOrange]: {
                primaryColor: "#F9DCD1",
                secondaryColor: "#E9835E",
                iconColor: "#C43501",
                textColor: "#7A2101",
                hoverColor: "#F4BFAB",
                calendarColor: "#DA3B01",
                hoverTextBorderColor: "#7A2101",
                pressedBackgroundColor: "#E9835E",
                pressedTextBorderColor: "#230900",
            },
            
            [CategoryColor.Bronze]: {
                primaryColor: "#F1D9CC",
                secondaryColor: "#CA8057",
                iconColor: "#A74109",
                textColor: "#5E2405",
                hoverColor: "#E5BBA4",
                calendarColor: "#A74109",
                hoverTextBorderColor: "#5E2405",
                pressedBackgroundColor: "#CA8057",
                pressedTextBorderColor: "#1B0A01",
            },
            
            [CategoryColor.Peach]: {
                primaryColor: "#FFDDB3",
                secondaryColor: "#FFBA66",
                iconColor: "#8F4E00",
                textColor: "#4D2A00",
                hoverColor: "#FFBA66",
                calendarColor: "#FF8C00",
                hoverTextBorderColor: "#4D2A00",
                pressedBackgroundColor: "#FFA83D",
                pressedTextBorderColor: "#291600",
            },
            
            [CategoryColor.Marigold]: {
                primaryColor: "#FCEFD3",
                secondaryColor: "#F2C661",
                iconColor: "#835B00",
                textColor: "#463100",
                hoverColor: "#F2C661",
                calendarColor: "#EAA300",
                hoverTextBorderColor: "#463100",
                pressedBackgroundColor: "#F2C661",
                pressedTextBorderColor: "#251A00",
            },
            
            [CategoryColor.Gold]: {
                primaryColor: "#F5EECE",
                secondaryColor: "#DAC157",
                iconColor: "#6C5700",
                textColor: "#3A2F00",
                hoverColor: "#DAC157",
                calendarColor: "#C19C00",
                hoverTextBorderColor: "#3A2F00",
                pressedBackgroundColor: "#D0B232",
                pressedTextBorderColor: "#1F1900",
            },
            
            [CategoryColor.DarkBrown]: {
                primaryColor: "#CAADA3",
                secondaryColor: "#946B5C",
                iconColor: "#4D291C",
                textColor: "#2B1710",
                hoverColor: "#E3D2CB",
                calendarColor: "#4D291C",
                hoverTextBorderColor: "#0C0704",
                pressedBackgroundColor: "#CAADA3",
                pressedTextBorderColor: "#0C0704",
            },
            
            [CategoryColor.Lime]: {
                primaryColor: "#E5F1D3",
                secondaryColor: "#A4CC6C",
                iconColor: "#405F14",
                textColor: "#22330B",
                hoverColor: "#A4CC6C",
                calendarColor: "#73AA24",
                hoverTextBorderColor: "#22330B",
                pressedBackgroundColor: "#A4CC6C",
                pressedTextBorderColor: "#121B06",
            },
            
            [CategoryColor.Forest]: {
                primaryColor: "#BDD99B",
                secondaryColor: "#85B44C",
                iconColor: "#294903",
                textColor: "#162702",
                hoverColor: "#85B44C",
                calendarColor: "#498205",
                hoverTextBorderColor: "#162702",
                pressedBackgroundColor: "#6BA02B",
                pressedTextBorderColor: "#0C1501",
            },
            
            [CategoryColor.LightGreen]: {
                primaryColor: "#CEF0CD",
                secondaryColor: "#5EC75A",
                iconColor: "#0E7A0B",
                textColor: "#063004",
                hoverColor: "#5EC75A",
                calendarColor: "#13A10E",
                hoverTextBorderColor: "#063004",
                pressedBackgroundColor: "#5EC75A",
                pressedTextBorderColor: "#063004",
            },
            
            [CategoryColor.DarkGreen]: {
                primaryColor: "#9AD29A",
                secondaryColor: "#4DA64D",
                iconColor: "#085108",
                textColor: "#032003",
                hoverColor: "#4DA64D",
                calendarColor: "#0B6A0B",
                hoverTextBorderColor: "#032003",
                pressedBackgroundColor: "#2D8E2D",
                pressedTextBorderColor: "#021102",
            },
            
            [CategoryColor.LightTeal]: {
                primaryColor: "#A6E9ED",
                secondaryColor: "#58D3DB",
                iconColor: "#00666D",
                textColor: "#00373A",
                hoverColor: "#58D3DB",
                calendarColor: "#00B7C3",
                hoverTextBorderColor: "#00373A",
                pressedBackgroundColor: "#32C8D1",
                pressedTextBorderColor: "#001D1F",
            },
            
            [CategoryColor.DarkTeal]: {
                primaryColor: "#92D1D1",
                secondaryColor: "#41A3A3",
                iconColor: "#003939",
                textColor: "#003939",
                hoverColor: "#C2E7E7",
                calendarColor: "#006666",
                hoverTextBorderColor: "#001010",
                pressedBackgroundColor: "#218B8B",
                pressedTextBorderColor: "#001010",
            },
            
            [CategoryColor.Steel]: {
                primaryColor: "#94C8D4",
                secondaryColor: "#4496A9",
                iconColor: "#005B70",
                textColor: "#00333F",
                hoverColor: "#C3E1E8",
                calendarColor: "#005B70",
                hoverTextBorderColor: "#000F12",
                pressedBackgroundColor: "#94C8D4",
                pressedTextBorderColor: "#000F12",
            },
            
            [CategoryColor.SkyBlue]: {
                primaryColor: "#D4F4FD",
                secondaryColor: "#63D7F7",
                iconColor: "#006A88",
                textColor: "#004659",
                hoverColor: "#63D7F7",
                calendarColor: "#00BCF2",
                hoverTextBorderColor: "#004659",
                pressedBackgroundColor: "#63D7F7",
                pressedTextBorderColor: "#001C24",
            },
            
            [CategoryColor.DarkBlue]: {
                primaryColor: "#C2D6E7",
                secondaryColor: "#4178A3",
                iconColor: "#003966",
                textColor: "#002039",
                hoverColor: "#92B5D1",
                calendarColor: "#003966",
                hoverTextBorderColor: "#002039",
                pressedBackgroundColor: "#C2D6E7",
                pressedTextBorderColor: "#000910",
            },
            
            [CategoryColor.Lavender]: {
                primaryColor: "#E7E4FB",
                secondaryColor: "#A79CF1",
                iconColor: "#6656D1",
                textColor: "#3F3682",
                hoverColor: "#D2CCF8",
                calendarColor: "#7160E8",
                hoverTextBorderColor: "#3F3682",
                pressedBackgroundColor: "#A79CF1",
                pressedTextBorderColor: "#120F25",
            },
            
            [CategoryColor.DarkPurple]: {
                primaryColor: "#B9A3D3",
                secondaryColor: "#7E5CA7",
                iconColor: "#512B7E",
                textColor: "#240F3C",
                hoverColor: "#D8CCE7",
                calendarColor: "#401B6C",
                hoverTextBorderColor: "#240F3C",
                pressedBackgroundColor: "#D8CCE7",
                pressedTextBorderColor: "#0A0411",
            },
            
            [CategoryColor.Pink]: {
                primaryColor: "#FBDDF0",
                secondaryColor: "#EF85C8",
                iconColor: "#AD2D7E",
                textColor: "#80215D",
                hoverColor: "#F7C0E3",
                calendarColor: "#E43BA6",
                hoverTextBorderColor: "#80215D",
                pressedBackgroundColor: "#EF85C8",
                pressedTextBorderColor: "#24091B",
            },
            
            [CategoryColor.Plum]: {
                primaryColor: "#D696C0",
                secondaryColor: "#AD4589",
                iconColor: "#87105D",
                textColor: "#43002B",
                hoverColor: "#E9C4DC",
                calendarColor: "#77004D",
                hoverTextBorderColor: "#43002B",
                pressedBackgroundColor: "#E9C4DC",
                pressedTextBorderColor: "#13000C",
            },
            
            [CategoryColor.Beige]: {
                primaryColor: "#EAE8E8",
                secondaryColor: "#AFABAA",
                iconColor: "#6E6968",
                textColor: "#444241",
                hoverColor: "#D7D4D4",
                calendarColor: "#7A7574",
                hoverTextBorderColor: "#444241",
                pressedBackgroundColor: "#AFABAA",
                pressedTextBorderColor: "#141313",
            },
            
            [CategoryColor.Mink]: {
                primaryColor: "#CECCCB",
                secondaryColor: "#9E9B99",
                iconColor: "#474443",
                textColor: "#343231",
                hoverColor: "#9E9B99",
                calendarColor: "#5D5A58",
                hoverTextBorderColor: "#0F0E0E",
                pressedBackgroundColor: "#84817E",
                pressedTextBorderColor: "#0F0E0E",
            },
            
            [CategoryColor.Silver]: {
                primaryColor: "#D8DFE0",
                secondaryColor: "#B3BFC2",
                iconColor: "#657174",
                textColor: "#282D2E",
                hoverColor: "#B3BFC2",
                calendarColor: "#859599",
                hoverTextBorderColor: "#282D2E",
                pressedBackgroundColor: "#A0AEB1",
                pressedTextBorderColor: "#151818",
            },
            
            [CategoryColor.Charcoal]: {
                primaryColor: "#C4C4C4",
                secondaryColor: "#888888",
                iconColor: "#333333",
                textColor: "#202020",
                hoverColor: "#888888",
                calendarColor: "#393939",
                hoverTextBorderColor: "#090909",
                pressedBackgroundColor: "#C4C4C4",
                pressedTextBorderColor: "#090909",
            },
        };
    }
    return cachedLightMap;
}
